import React, { Component } from "react";
import axios from "axios";
import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { Card, Grid, TextField } from "@mui/material";
import { Navigate } from "react-router-dom";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";

import MediaPickerModal from "Main/Modals/MediaModal";

export default class UpdateGallery extends Component {
  state = {
    id: null,
    title: "",
    img_alt_text: "",
    selectedImage: null,
    showMediaModal: false,

    notification: false,
    message: "",
    redirect: false,
    loading: false,
  };

  componentDidMount() {
    this.getGalleryDetails();
  }

  // ✅ SAME AS YOUR LEVEL CODE (get id from URL)
  getId = () => {
    return window.location.pathname.split("/")[2];
  };

  // ✅ FETCH DETAILS
  getGalleryDetails = async () => {
    try {
      const id = this.getId();

      if (init() === "success") {
        const resp = await axios.post(
          Constants.getUrls.getGalleryDetails,
          { id }
        );

        const data = resp.data.data;

        this.setState({
          id: data.id,
          title: data.title,
          img_alt_text: data.img_alt_text,
          selectedImage: {
            id: data.image_id,
            image_path: data.image_path,
          },
        });
      } else {
        window.location.assign("/signin");
      }
    } catch (err) {
      console.log(err);
    }
  };

  // 🔹 HANDLE INPUT
  handleInput = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  // 🔥 UPDATE SUBMIT
  handleSubmit = async (e) => {
    e.preventDefault();

    const { id, title, img_alt_text, selectedImage } = this.state;

    if (!selectedImage) {
      return this.setState({
        notification: true,
        message: "Please select an image",
      });
    }

    const payload = {
      id,
      title,
      img_alt_text,
      image_id: selectedImage.id,
    };

    try {
      if (init() === "success") {
        this.setState({ loading: true });

        const resp = await axios.post(
          Constants.putUrls.updateGallery,
          payload
        );

        this.setState({
          notification: true,
          message: resp.data.message || "Updated successfully!",
          loading: false,
        });

        setTimeout(() => {
          this.setState({ redirect: true });
        }, 2000);
      } else {
        window.location.assign("/signin");
      }
    } catch (err) {
      console.log(err);

      this.setState({
        notification: true,
        message: err?.response?.data?.message || "Something went wrong!",
        loading: false,
      });
    }
  };

  render() {
    if (this.state.redirect) {
      return <Navigate to="/gallery" />;
    }

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              bgColor="info"
              borderRadius="lg"
            >
              <MDTypography variant="h6" color="white">
                Update Gallery
              </MDTypography>
            </MDBox>

            <MDBox py={3} px={2}>
              <form onSubmit={this.handleSubmit}>
                <Grid container spacing={2}>

                  {/* Title */}
                  <Grid item sm={6}>
                    <TextField
                      label="Title"
                      name="title"
                      value={this.state.title}
                      onChange={this.handleInput}
                      fullWidth
                    />
                  </Grid>

                  {/* Alt Text */}
                  <Grid item sm={6}>
                    <TextField
                      label="Image Alt Text"
                      name="img_alt_text"
                      value={this.state.img_alt_text}
                      onChange={this.handleInput}
                      fullWidth
                    />
                  </Grid>

                  {/* Image */}
                  <Grid item sm={6}>
                    <MDButton
                      variant="contained"
                      color="info"
                      onClick={() => this.setState({ showMediaModal: true })}
                    >
                      Change Image
                    </MDButton>

                    {this.state.selectedImage && (
                      <img
                        src={
                          Constants.imageDomain +
                          this.state.selectedImage.image_path
                        }
                        style={{
                          width: 80,
                          height: 80,
                          marginTop: 10,
                          borderRadius: 6,
                          objectFit: "cover",
                        }}
                      />
                    )}
                  </Grid>

                </Grid>

                <Grid mt={2}>
                  <MDButton variant="contained" color="info" type="submit">
                    {this.state.loading ? "Updating..." : "Update Gallery"}
                  </MDButton>
                </Grid>
              </form>
            </MDBox>

            <MDSnackbar
              color="success"
              title="Gallery"
              content={this.state.message}
              open={this.state.notification}
            />

            {/* Media Modal */}
            <MediaPickerModal
              visible={this.state.showMediaModal}
              multiple={false}
              onClose={() => this.setState({ showMediaModal: false })}
              onSelect={(images) => {
                this.setState({
                  selectedImage: images[0],
                  showMediaModal: false,
                });
              }}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}